export { default as DetalleRecepcionHistorico } from './HistoricoRecepciones/Ver'
export { default as HistoricoRecepciones } from './HistoricoRecepciones/Listar'
export { default as RecepcionHistoricoBoleta } from './HistoricoRecepciones/VerBoleta'
export { default as DetalleLiquidacionHistorico } from './HistoricoLiquidaciones/Ver'
export { default as HistoricoLiquidaciones } from './HistoricoLiquidaciones/Listar'
export { default as LiquidacionHistoricoBoleta } from './HistoricoLiquidaciones/VerBoleta'